module.exports = __webpack_public_path__ + "static/media/26UNRWA3.c5049061.jpg";